import { GetLiquidCustomerGroupings, InsertLiquidCustomerGroupings, UpdateLiquidCustomerGroupings } from "../../../services/requests";
import { DataSource } from "../../UI/view/data-source";

export const groupingsDataSource = {
  name: 'liquidCusGroupings',
  pk: 'id',
  request: GetLiquidCustomerGroupings,
  updateRequest: UpdateLiquidCustomerGroupings,
  createRequest: InsertLiquidCustomerGroupings
} as DataSource;